// Length presets set the product quantity (metres) and mirror it in a plain-language summary.
class SLengthPresets extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    this.addEventListener('command', (event) => {
      if (event.command !== '--set-length') return;
      const length = parseInt(event.source?.dataset.length, 10);
      const input = this.querySelector('input[name="quantity"]');
      if (!input || isNaN(length)) return;
      input.value = String(length);
      // The quantity selector normalizes on change and emits s-quantity:change.
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this.#sync();
    }, opts);

    this.addEventListener('s-quantity:change', () => this.#sync(), opts);
    this.querySelector('input[name="quantity"]')?.addEventListener('input', () => this.#sync(), opts);
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const input = this.querySelector('input[name="quantity"]');
    if (!input) return;
    const value = parseInt(input.value, 10) || 1;

    this.querySelectorAll('[data-length]').forEach((button) => {
      const isMatch = parseInt(button.dataset.length, 10) === value;
      button.setAttribute('aria-pressed', String(isMatch));
    });

    const count = this.querySelector('[data-length-count]');
    const unit = this.querySelector('[data-length-unit]');
    if (count) count.textContent = String(value);
    if (unit) unit.textContent = value === 1 ? this.dataset.unitOne : this.dataset.unitOther;
  }
}

customElements.define('s-length-presets', SLengthPresets);
